// ===================================================
// ФАЙЛ: frontend/src/config/theme.js
// Глобальная конфигурация Ant Design темы для markbase.ru
// Единый источник токенов дизайна — все компоненты используют эти значения
// Style AI: для правки визуальных значений изменять токены здесь и CSS-переменные в index.css
// ===================================================

/**
 * Базовые цветовые токены (значения синхронизированы с CSS custom properties в index.css).
 * Style AI заменит на фирменную палитру Markbase.
 */
const colors = {
  primary:       '#0284C7', // var(--brand)
  primaryHover:  '#38BDF8', // var(--brand-light)
  primaryActive: '#0369A1', // Darker brand
  success:       '#10B981', // var(--ok)
  warning:       '#F59E0B', // var(--warn)
  error:         '#EF4444', // var(--err)
  info:          '#3B82F6', // var(--info)
};

/**
 * Ant Design v5 design token конфигурация.
 * Передаётся в <ConfigProvider theme={antdTheme}>.
 *
 * Правила:
 * - Все значения только через константы этого файла — не хардкод в компонентах
 * - theme.useToken() в компонентах для чтения токенов во время рендера
 * - CSS custom properties в index.css дублируют базовые токены для доступа из чистого CSS
 */
export const antdTheme = {
  token: {
    // Цвета
    colorPrimary:   colors.primary,
    colorSuccess:   colors.success,
    colorWarning:   colors.warning,
    colorError:     colors.error,
    colorInfo:      colors.info,

    // Типографика — шрифт Inter (Design System 2026)
    fontFamily:     "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize:       14,
    lineHeight:     1.5715,

    // Радиусы скруглений (S0 DS 2026: xs:6, sm:10, md:12, lg:16)
    borderRadius:   12,
    borderRadiusLG: 16,
    borderRadiusSM: 10,
    borderRadiusXS: 6,

    // Тени — синхронизированы с tokens.css (sh-md, sh-lg)
    boxShadow:      '0 6px 16px -2px rgba(11, 16, 30, 0.08), 0 2px 6px -1px rgba(11, 16, 30, 0.04)',
    boxShadowSecondary: '0 12px 32px -4px rgba(11, 16, 30, 0.1), 0 4px 12px -2px rgba(11, 16, 30, 0.05)',

    // Отступы
    padding:        16,
    paddingLG:      24,
    paddingSM:      12,
    paddingXS:      8,
    paddingXXS:     4,

    /**
     * Слой всплывающих окон Ant Design v5 (Modal mask, Select, DatePicker, Popover…).
     * Дефолт Ant: 1000 — ниже DS `mb-modal-backdrop` (--z-modal: 2000) и панелей ~2001–2100,
     * из‑за чего выпадающие списки и Modal оказываются «под» кастомными модалками (не видно / моргание).
     * 2120: выше типичного вложенного mb-modal (до ~2100), ниже --z-toast (3000).
     */
    zIndexPopupBase: 2120,

    // Размер иконок (stroke 1.5–2.0 в компонентах)
    fontSizeIcon:   16,

    // Анимации
    motionDurationMid:   '0.2s',
    motionDurationSlow:  '0.3s',
    motionDurationFast:  '0.1s',
  },

  components: {
    // Layout
    Layout: {
      headerHeight:  60,
      siderWidth:    248,
      headerPadding: '0 24px',
      headerBg:      '#ffffff',
      bodyBg:        '#f5f5f5',
      siderBg:       '#ffffff',
      footerBg:      '#ffffff',
      footerPadding: '16px 24px',
    },

    // Menu / Sidebar
    Menu: {
      itemHeight:         44,
      itemPaddingInline:  16,
      iconSize:           18,
      iconMarginInlineEnd: 10,
    },

    // Кнопки
    Button: {
      primaryShadow:  'none',
      defaultShadow:  'none',
      dangerShadow:   'none',
    },

    // Таблицы
    Table: {
      headerBg:    '#fafafa',
      rowHoverBg:  '#f5f5f5',
      borderColor: '#f0f0f0',
    },

    // Карточки
    Card: {
      paddingLG: 24,
    },

    // Поля ввода
    Input: {
      activeShadow: `0 0 0 2px rgba(${hexToRgb(colors.primary)}, 0.12)`,
    },
  },
};

/**
 * Вспомогательная функция: HEX → RGB (для использования в box-shadow rgba).
 * Используется только внутри этого файла.
 */
function hexToRgb(hex) {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}
